import produce from 'immer';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, IConsultarRelacaoUsuarioState } from './types';

export const INITIAL_STATE: IConsultarRelacaoUsuarioState = {
	status: 0,
	data: null,
	totalRegistrosConsulta: 0,
	previousRequest: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): IConsultarRelacaoUsuarioState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_RELACAO_USUARIO_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.previousRequest = action.payload;
				break;
			}
			case Types.CONSULTAR_RELACAO_USUARIO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				draft.totalRegistrosConsulta =
					action.payload.headers['x-num-registros'];
				break;
			}

			case Types.CONSULTAR_RELACAO_USUARIO_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CONSULTAR_RELACAO_USUARIO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.previousRequest = INITIAL_STATE.previousRequest;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				break;
			}

			default:
		}
		return draft;
	});
}
